<script setup lang="ts">
  import { computed, useId } from 'vue';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import ContentContainer from '../ContentContainer/ContentContainer.vue';
  import { ContentContainerVariant } from '../ContentContainer/ContentContainer.types';
  import FontIcon from '../FontIcon/FontIcon.vue';
  import { FontIconSize } from '../FontIcon/FontIcon.types';
  import PageIntro from '../PageIntro/PageIntro.vue';
  import type { AuthPageContentProps } from './AuthPageContent.types';
  import {
    authContentClass,
    authContentWrapperClass,
    authIntroClass,
    lightningIconClass,
  } from './AuthPageContent.css';

  const props = defineProps<AuthPageContentProps>();

  const uid = useId();
  const resolvedTestId = computed(
    () => props.testId ?? `ds-auth-page-content-${uid}`,
  );
</script>

<template>
  <div :id="id" :class="authContentWrapperClass" :data-testid="resolvedTestId">
    <div :class="authIntroClass">
      <PageIntro :title="title" :subtitle="subTitle" centered>
        <template #topWidget>
          <span :class="lightningIconClass">
            <FontIcon
              :icon-name="TUNDR_ICONS.LIGHTNING_SOLID"
              :size="FontIconSize.Hero"
            />
          </span>
        </template>
        <template v-if="$slots.actions" #extraContent>
          <slot name="actions" />
        </template>
      </PageIntro>
    </div>
    <ContentContainer :variant="ContentContainerVariant.FixedNarrow">
      <div :class="authContentClass"><slot /></div>
    </ContentContainer>
  </div>
</template>
